import { Button, Divider, Input, Modal } from "antd";
import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  setDraftDialogEditorEdit,
  updateTimelineAction,
} from "store/bailiff/draft/dialog/draft_dialog.action";
import { draftDialogEditorEditSelector } from "store/bailiff/draft/dialog/draft_dialog.selector";
//
//component
//redux
//selector
//actions
//utils
//hook
//str
const DialogLabelEdit = () => {
  // -------------------------- VAR -----------------------------
  // -------------------------- STATE ---------------------------
  const [text, setText] = useState("");

  // -------------------------- REDUX ---------------------------
  const dispatch = useDispatch();
  const data = useSelector(draftDialogEditorEditSelector);
  const open = !!data;
  const action = data?.action || null;
  const id = data?.id || null;
  const origin = data?.origin || null;
  // -------------------------- FUNCTION ------------------------
  const handleCancel = useCallback(() => {
    dispatch(setDraftDialogEditorEdit(null));
  }, [dispatch]);

  const handleSave = useCallback(() => {
    if (!action || !id || !origin) return;
    dispatch(updateTimelineAction({ origin, id, actionId: action.id, text }));
    handleCancel();
  }, [action, dispatch, handleCancel, id, origin, text]);

  // -------------------------- EFFECT --------------------------
  useEffect(() => {
    if (open && action) {
      setText(action.content);
    }
  }, [open, action]);
  // -------------------------- DATA FUNCTION -------------------
  // -------------------------- RENDER --------------------------
  const renderBody = () => {
    return (
      <Input.TextArea
        value={text}
        onChange={(e) => setText(e?.target?.value)}
        rows={10}
      />
    );
  };
  // -------------------------- MAIN ----------------------------
  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      title="Chỉnh sửa đoạn này"
      footer={null}
      centered
    >
      <Divider className="my-4" />
      {renderBody()}
      <Divider className="my-4" />
      <div className="flex flex-row items-center justify-end gap-1">
        <Button onClick={handleCancel}>Huỷ</Button>
        <Button
          className="bg-green-600 hover:!bg-green-700"
          type="primary"
          onClick={handleSave}
        >
          Lưu
        </Button>
      </div>
    </Modal>
  );
};
export default DialogLabelEdit;
